<template>
  <div>
    <el-card  :class="{ 'hide-body': !showFilters }">
      <div slot="header" class="d-flex space-between">
        <h3>Confirma y crea  n&oacute;minas</h3>
        <el-button size="mini" plain @click="showFilters = !showFilters">
          <i v-if="!showFilters" class="icon el-icon-arrow-down "></i>
          <i v-if="showFilters" class="icon el-icon-arrow-up "></i>
        </el-button>
      </div>
      <el-row :gutter="10" v-if="showFilters">
        <el-col :md="6">
          <el-select v-model="filters.payroll_id"
                     :disabled="loaded"
                     @change="onChangeOption()"
                     placeholder="Seleccionar Planilla"
                     style="width: 100%">
            <el-option
              v-for="item in payrolls"
              :key="item.id"
              :label="item.name"
              :value="item.id">
              <span style="float: left">{{ item.name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.type }}</span>
            </el-option>
          </el-select>
        </el-col>
        <el-col :md="6">
          <el-select v-model="filters.option_id"
                     :disabled="loaded"
                     @change="onChangeOption()"
                     placeholder="Seleccionar Planilla"
                     style="width: 100%">
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :md="12">
          <el-date-picker
            v-if="filters.option_id == 2"
            :disabled="loaded"
            v-model="filters.range"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="a"
            start-placeholder="Fecha de Inicio"
            end-placeholder="Fecha Final"
            :picker-options="pickerOptions2">
          </el-date-picker>

          <el-select v-model="filters.report"
                     :disabled="loaded"
                     v-if="filters.option_id == 1"
                     :placeholder="loadingReports ? 'Cargando...' : 'Seleccionar Periodo'"
                     style="width: 100%">
            <el-option
              v-for="item in reportDates"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="10" style="margin-top: 20px" v-if="showFilters">
        <el-col :md="24">
          <el-button type="primary" :disabled="!validForm()" @click="confirmGeneratePayroll()" :loading="loading" plain>Cargar Datos</el-button>
          <el-button type="success" v-if="loaded" @click="confirmAll()" plain>Confirmar Planilla</el-button>
          <el-dropdown split-button type="warning" trigger="click" style="margin: 0 10px 0 10px" v-if="loaded" @command="createDraft" @click="dialogVisible = true">
            Subir Datos
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="costCenterIds">Planilla Completa</el-dropdown-item>
              <el-dropdown-item v-for="costCenter of costCenters" :key="costCenter.id" :command="costCenter.id">{{costCenter.name}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="default" v-if="loaded" @click="cancel()" plain>Cancelar</el-button>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="card-table" v-loading="loading">
      <div slot="header" class="card-header clearfix">
        <el-input type="search" placeholder="Buscar"
                  v-model="search"
                  @input="searchInTable"></el-input>
      </div>
      <div id="hot-preview">
        <HotTable :root="root" :settings="tableSettings" ref="myHotTableRef"></HotTable>
      </div>
    </el-card>

    <el-dialog
      title="Subir Datos"
      :visible.sync="dialogVisible"
      width="30%">
      <el-upload
        drag
        :limit="1"
        :action="baseApi + '/reports/read-draft'"
        class="upload-demo"
        ref="upload"
        :auto-upload="false"
        with-credentials
        :http-request="submitDraft"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">Suelta tu archivo aquí o <em>haz clic para cargar</em></div>
      </el-upload>
       <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">Cancel</el-button>
          <el-button type="primary" @click="uploadDraft">Guardar</el-button>
        </span>
    </el-dialog>

  </div>
</template>
<script>
  import HotTable from '@handsontable/vue'
  import {baseApi} from '../../configs/urls'
  import {Converter, params, parseError} from '../../packages/Helpers'
  import * as moment from 'moment'
  import {saveAs} from 'file-saver'
  const FormulaParser = require('hot-formula-parser').Parser
  export default {
    name: 'liquidation',
    components: {
      HotTable
    },
    data () {
      const _this = this
      return {
        root: 'test-hot',
        showFilters: true,
        search: '',
        data: [],
        costCenters: [],
        exporting: false,
        dialogVisible: false,
        baseApi: baseApi,
        submitDraft: (request) => {
          const data = Converter.objectToFormData({ ...this.getBaseData(), draft: request.file })

          this.$http.post(
            `${baseApi}/reports/read-draft`,
            data,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          )
            .then(
              (res) => {
                this.loadReports()
                this.dialogVisible = false
                request.onSuccess(res)
              },
              (res) => {
                this.$message.error(parseError(res)[0])
                this.exporting = false
                request.onError(res)
              }
            )
        },
        tableSettings: {
          fixedColumnsLeft: 0,
          manualColumnResize: true,
          manualRowResize: true,
          data: [],
          columns: [],
          colHeaders: [],
          afterChange (changes, source) {
            if (changes !== null && (source === 'edit' || source === 'Autofill.fill')) {
              changes.forEach((change) => {
                if (change) {
                  _this.updateRow(change[0])
                }
              })
            }
          },
          contextMenu: {
            items: {
              'freeze_column': {
                name: 'Fijar columna'
              },
              'unfreeze_column': {
                name: 'Movilizar columna'
              },
              'remove_row': {
                name: 'Eliminar Registro',
                callback: function (param1, param2) {
                  if (param2.length > 0 && param2[0].end.row === param2[0].start.row) {
                    const rowNumber = this.getSelected()[0][0]
                    const row = this.getSourceDataAtRow(rowNumber)
                    _this.deleteRow(rowNumber, row.id)
                  }
                }
              },
              'send_email': {
                name: 'Enviar Comprobante de pago',
                callback: function (param1, param2) {
                  if (param2.length > 0 && param2[0].end.row === param2[0].start.row) {
                    const rowNumber = this.getSelected()[0][0]
                    const row = this.getSourceDataAtRow(rowNumber)
                    _this.sendEmail(rowNumber, row.id)
                  }
                }
              },
              'ignore_child_support': {
                name: 'Ignorar pensión alimenticia',
                callback: function (param1, param2) {
                  if (param2.length > 0 && param2[0].end.row === param2[0].start.row) {
                    const rowNumber = this.getSelected()[0][0]
                    const row = this.getSourceDataAtRow(rowNumber)
                    _this.sendIgnoreChildSupport(rowNumber, row.id)
                  }
                }
              }
            }
          },
          height: 600,
          manualColumnFreeze: true,
          allowInsertColumn: false,
          allowInsertRow: false
        },
        columnsMeta: [],
        loadingPayRolls: false,
        loaded: false,
        payrolls: [],
        filters: {
          option_id: 2
        },
        options: [
          {id: 1, name: 'Cargar Existente'},
          {id: 2, name: 'Nueva'}
        ],
        loadingReports: false,
        reportDates: [],
        loading: false,
        processingConfirmation: false,
        pickerOptions2: {
          shortcuts: [
            {
              text: 'Ultima Semana',
              onClick (picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: 'Ultima 15 dias',
              onClick (picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 15)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: 'Mes Pasado',
              onClick (picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                picker.$emit('pick', [start, end])
              }
            }
          ]
        }
      }
    },
    methods: {
      confirmGeneratePayroll () {
        if (this.filters.option_id === 2) {
          this.$confirm('Esta seguro que desea crear una nueva nomina', '¿Crear nomina?', {
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar',
            type: 'warning'
          })
          .then(() => this.loadReports())
          .catch(() =>
            this.$message({ type: 'info', message: 'Creación de nomina cancelada...' })
          )
        } else {
          this.loadReports()
        }
      },
      validateNumber (value, callback) {
        if (isNaN(value) || value < 0) {
          callback(false)
        }
        callback(true)
      },
      onChangeOption () {
        if (this.filters.option_id === 1 && this.filters.payroll_id) {
          this.reportDates = []
          this.loadingReports = true
          const data = {
            payroll_id: this.filters.payroll_id
          }
          this.$http.get(baseApi + '/reports' + params(data))
            .then(
              (response) => {
                this.reportDates = response.body
                this.loadingReports = false
              },
              (res) => {
                this.$message.error(parseError(res)[0])
                this.loadingReports = false
              }
            )
        }
      },
      validForm () {
        if (this.filters.payroll_id && (this.filters.range || this.filters.report)) {
          return true
        }
        return false
      },
      getBaseData () {
        let data = {
          payroll_id: this.filters.payroll_id,
          init_date: '',
          end_date: ''
        }

        if (this.filters.option_id === 1) {
          let result = this.reportDates.filter((item) => {
            return item.value === this.filters.report
          })
          if (result.length > 0) {
            data.init_date = result[0].init_date
            data.end_date = result[0].end_date
          }
        } else {
          data.init_date = moment(this.filters.range[0]).format('YYYY-MM-DD')
          data.end_date = moment(this.filters.range[1]).format('YYYY-MM-DD')
        }
        return data
      },
      loadReports () {
        if (!this.validForm()) {
          this.$message.error('Verifica que esten todos los campos llenos.')
          return
        }

        const data = this.getBaseData()

        this.tableSettings.data = []
        this.loading = true
        this.$http.get(baseApi + '/reports/create' + params(data))
          .then(
            (response) => {
              const data = response.body
              const params = data.params
              this.columnsMeta = params

              this.columnsMeta = Object.keys(params).map((param) => {
                let output = Object.assign({}, params[param])
                output.key = param
                return output
              })

              let columns = []
              let headers = data.headers
              if (data.data.length > 0) {
                columns = headers.map((key) => {
                  let output = {
                    data: key.replace(/ /g, '_')
                  }
                  let result = null
                  for (let index in params) {
                    if (index && params.hasOwnProperty(index) && index === output.data && params[index].editable === true) {
                      result = params[index]
                      break
                    }
                  }

                  if (result) {
                    if (result['type'] && result['type'] !== 'numeric') {
                      output.type = result['type']
                    } else {
                      output.validator = this.validateNumber
                      output.allowInvalid = false
                    }
                  } else {
                    for (let index in params) {
                      if (index && params.hasOwnProperty(index) && index === output.data && params[index].formula) {
                        result = params[index]
                        break
                      }
                    }

                    if (result) {
                      output.type = 'numeric'
                      output.numericFormat = {
                        pattern: '0.00'
                      }
                    }
                    output.readOnly = true
                  }

                  return output
                })
              }

              this.tableSettings.data = data.data
              this.data = this.copyData(data.data)
              this.tableSettings.columns = columns
              this.tableSettings.colHeaders = headers
              this.costCenters = data.cost_centers
              this.loading = false
              this.loaded = true
            },
            (res) => {
              this.$message.error(parseError(res)[0])
              this.loading = false
              this.loaded = true
            }
          )
      },
      updateRow (index) {
        if (!this.tableSettings.data[index].id) {
          return
        }
        const parser = new FormulaParser()
        const row = Object.assign({}, this.tableSettings.data[index])

        this.tableSettings.data.forEach((meta) => {
          if (row.hasOwnProperty(meta.key)) {
            parser.setVariable(meta.key, row[meta.key])
          }
        })

        Object.keys(row).forEach((key) => {
          if (row.hasOwnProperty(key)) {
            parser.setVariable(key, row[key])
            console.log('parser row', key, row[key], row)
          }
        })

        this.columnsMeta.filter(meta => meta.formula)
          .forEach((meta) => {
            if (row.hasOwnProperty(meta.key)) {
              const parseResult = parser.parse(meta.formula)
              if (parseResult.error) {
                console.log(meta.key, parseResult.error)
              }

              let result = parseResult.result
              parser.setVariable(meta.key, result)
              if (meta.roundType) {
                result = Math[meta.roundType](result)
              }
              this.tableSettings.data[index][meta.key] = result
            }
          })

        this.$http.post(baseApi + '/reports', this.tableSettings.data[index])
          .then(
            () => {},
            (res) => {
              this.$message.error('Ocurrio un error al intentar guardar la linea ' + (index + 1) + '. ' + parseError(res)[0])
              this.tableSettings.data[index] = row
            }
          )
      },
      deleteRow (row, id) {
        this.loading = true

        if (!id) {
          this.loading = false
          return
        }

        this.$http.delete(baseApi + '/reports/' + id, id)
          .then(
            () => {
              this.loading = false
              this.data = this.data.filter(item => item.id !== id)
              this.$refs.myHotTableRef.hotInstance.alter('remove_row', row, 1)
            },
            (res) => {
              this.$message.error('Ocurrio un error al intentar eliminar una linea ')
              this.loading = false
            }
          )
      },
      sendEmail (row, id) {
        this.loading = true

        if (!id) {
          this.loading = false
          return
        }

        this.$http.get(baseApi + '/reports/' + id, id)
          .then(
            () => {
              this.loading = false
            },
            (res) => {
              this.$message.error('Ocurrio un error al enviar el correo electronico')
              this.loading = false
            }
          )
      },
      sendIgnoreChildSupport (row, id) {
        this.loading = true

        if (!id) {
          this.loading = false
          return
        }

        this.$http.get(baseApi + '/reports/ignore/' + id, id)
          .then(
            () => {
              this.loading = false
            },
            (res) => {
              this.$message.error('Ocurrio un error al tratar de ignorar la pensión')
              this.loading = false
            }
          )
      },
      cancel () {
        this.filters = {
          option_id: 2
        }
        this.loaded = false
        this.tableSettings.data = []
      },
      confirmAll () {
        this.processingConfirmation = true
        this.$http.post(baseApi + '/reports/confirmation' + params(this.getBaseData()))
          .then(
            () => {
              this.cancel()
              this.processingConfirmation = false
              this.$message.success('Se ha confirmado correctamente')
            },
            (res) => {
              this.$message.error(parseError(res)[0])
              this.processingConfirmation = false
            }
          )
      },
      copyData (data) {
        return [...data]
      },
      searchInTable () {
        if (this.search !== '') {
          const searchables = this.columnsMeta.filter(meta => meta.search === true)
            .map(item => item.key)

          const data = this.copyData(this.data)
          this.tableSettings.data = data.filter((item) => {
            for (let key in item) {
              if (item.hasOwnProperty(key) && searchables.indexOf(key) >= 0) {
                if (item[key].toString().toLowerCase().includes(this.search.toLowerCase())) {
                  return true
                }
              }
            }
            return false
          })
        } else {
          this.tableSettings.data = this.copyData(this.data)
        }
      },
      createDraft (costCenterId) {
        this.exporting = true
        this.$http.post(`${baseApi}/reports/draft-excel`, { ...this.getBaseData(), cost_center_id: costCenterId }, {
          responseType: 'arraybuffer',
          headers: {'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}
        })
          .then(
            (response) => {
              const blob = new Blob([response.data], {type: 'application/octet-stream'})
              let filename = `${this.payrolls.find(p => p.id === this.filters.payroll_id).name}`
              if (!Array.isArray(costCenterId)) {
                filename += ` (${this.costCenters.find(c => c.id === costCenterId).name})`
              }
              saveAs(blob, filename + '.xlsx')
              this.exporting = false
            },
            (res) => {
              this.$message.error(parseError(res)[0])
              this.exporting = false
            }
          )
      },
      uploadDraft () {
        this.$refs.upload.submit()
      }
    },
    mounted () {
      this.loadingPayRolls = true
      this.$http.get(baseApi + '/payrolls')
        .then(
          (response) => {
            this.payrolls = response.body
            this.loadingPayRolls = false
          },
          (res) => {
            this.$message.error(parseError(res)[0])
            this.loadingPayRolls = false
          }
        )
    },
    computed: {
      costCenterIds () {
        return this.costCenters.map(x => x.id)
      }
    }
  }
</script>
<style>
  .el-card {
    margin-top: 30px
  }

  .el-card:last-child {
    margin-bottom: 100px
  }

  h3 {
    margin: 0
  }

  #test-hot td {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  #test-hot .ht_clone_left td,
  #test-hot .ht_clone_top_left_corner td {
    height: auto !important;
  }
  .el-button.el-button--warning {
    color: #E6A23C;
    background: #fdf6ec;
    border-color: #f5dab1;
    border-left-color: rgb(245, 218, 177);
  }
  .el-button.el-button--warning:hover, .el-button.el-button--warning:focus {
    background: #E6A23C;
    border-color: #E6A23C;
    border-right-color: rgb(230, 162, 60);
    color: #FFF;
  }
  .el-dropdown-menu {
    overflow-y: auto;
    max-height: 300px;
  }
  .el-upload.el-upload--text, .el-upload-dragger {
    width: 100%;
  }
</style>
<style src="handsontable/dist/handsontable.full.css"></style>



// WEBPACK FOOTER //
// src/views/reports/Liquidation.vue